import { StyledHoverTableRow } from '~/views/Admin/Admin.style';
import {
  ACTION_STATUS,
  THandleSelectedResources,
} from '~/components/Admin/ResourceTable';
import { uniqueId } from 'lodash';
import { cell } from '~/components/Admin/ResourceTable/ResourceTable.style';
import { Edit } from '@mui/icons-material';
import { Checkbox, Tooltip, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { TAdminResource } from '~/store/resource/resource.type';
import {
  formatTimeHourDate,
  formatTimeHourMinute,
} from '~/utils/helper/format';
import { SELECT_ACTION, adminTab } from '~/types/enum';
import { resourceCategory } from '~/api/oneBoxV3/oneBoxV3.type';

type TProps = {
  data: TAdminResource;
  tab: adminTab;
  isSelected: boolean;
  selectedResourcesLength: number;
  handleSelectedResources: ({
    type,
    resource,
  }: THandleSelectedResources) => void;
  setActionStatus: Dispatch<SetStateAction<ACTION_STATUS>>;
};

export const ResourceRow = ({
  data,
  tab,
  isSelected,
  selectedResourcesLength,
  handleSelectedResources,
  setActionStatus,
}: TProps) => {
  const cellDatas = [
    data.versions,
    data.years,
    data.eduCodes,
    data.subjects,
    data.grades,
    data.resources1,
    data.resources2,
    data.resources3,
    data.chapterKeyword,
    data.knowledge,
  ];
  return (
    <StyledHoverTableRow>
      <cell.Container sx={{ textAlign: 'center' }}>
        <Checkbox
          sx={{ padding: '0px' }}
          color="info"
          checked={isSelected}
          onChange={(_event, checked) => {
            const currentSelectedResourcesLength = checked
              ? selectedResourcesLength + 1
              : selectedResourcesLength - 1;
            setActionStatus(() => {
              return currentSelectedResourcesLength > 0
                ? ACTION_STATUS.SELECT
                : ACTION_STATUS.NON;
            });
            handleSelectedResources({
              type: checked ? SELECT_ACTION.ADD : SELECT_ACTION.DELETE,
              resource: data,
            });
          }}
        />
      </cell.Container>
      <cell.Container>
        {tab === adminTab.cramSchools ? (
          [data.categories.origin, ...data.categories.additional].map(
            (item, index) => (
              <cell.TypeChip
                key={item}
                size="small"
                label={item}
                type={item}
                sx={{ marginTop: index > 0 ? '8px' : '0px' }}
              />
            ),
          )
        ) : (
          <cell.TypeChip
            key={resourceCategory.SCHOOL}
            size="small"
            label={resourceCategory.SCHOOL}
            type={resourceCategory.SCHOOL}
            sx={{ marginTop: '0px' }}
          />
        )}
      </cell.Container>
      <cell.Container>
        <Typography fontSize="inherit">
          {formatTimeHourDate(data.createdAt)}
        </Typography>
        <Typography fontSize="inherit" fontWeight="400" color="grey.600">
          {formatTimeHourMinute(data.createdAt)}
        </Typography>
      </cell.Container>
      {cellDatas.map(list => (
        <cell.Container key={uniqueId()}>
          <Tooltip
            title={[list.origin, ...list.additional]
              .join(';')
              .replace(/^;+/, '')}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: '157px',
                  wordBreak: 'break-all',
                },
              },
            }}
          >
            <cell.EllipsisText fontSize="inherit" fontWeight="inherit">
              {list.origin}
              {/* {list.additional.length !== 0 && ';'} */}
              <Typography
                fontSize="inherit"
                fontWeight="inherit"
                color="warning.main"
                component="span"
              >
                {list.additional.length === 1
                  ? list.additional[0]
                  : [...list.additional].join(';')}
              </Typography>
            </cell.EllipsisText>
          </Tooltip>
        </cell.Container>
      ))}
      <cell.Container sx={{ minwidth: '75px' }}>
        <Tooltip
          title={data.displayName}
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: '157px',
                wordBreak: 'break-all',
              },
            },
          }}
        >
          <cell.EllipsisText fontSize="inherit" fontWeight="inherit">
            {data.displayName}
          </cell.EllipsisText>
        </Tooltip>
      </cell.Container>
      <cell.Container sx={{ minWidth: '75px' }}>
        <Tooltip
          title={data.fileName}
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: '157px',
                wordBreak: 'break-all',
              },
            },
          }}
        >
          <cell.EllipsisText fontSize="inherit" fontWeight="inherit">
            {data.fileName}
          </cell.EllipsisText>
        </Tooltip>
      </cell.Container>
      <cell.Container
        sx={{
          position: 'sticky',
          right: 0,
          backgroundColor: 'white',
          boxShadow: 'inset 1px 0 0 0 #DFE3E8',
          padding: '8px 10px 8px 8px',
        }}
      >
        <cell.EditIconButton
          onClick={() => {
            handleSelectedResources({
              type: SELECT_ACTION.EDIT,
              resource: data,
            });
            setActionStatus(ACTION_STATUS.EDIT);
          }}
        >
          <Edit sx={{ fill: 'info.main' }} />
        </cell.EditIconButton>
      </cell.Container>
    </StyledHoverTableRow>
  );
};
